import GoogleMap from "../components/map";


const sections = document.querySelectorAll('section.investment-map');

if (sections.length) {
    sections.forEach(section => {
        const map = section.querySelector('[data-map]');
        if (map) {
            const instance = new GoogleMap(map, true, true);
        }
    });
}
